(ns frontend.ui.component.text.view
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.component.text.style :as style]))

(defn text
  "Optional props: `:font-weight`, `:text-size`, `:color` (keyword from `theme/palette`). All other
  props will be passed as raw CSS."
  ([child]
   (text {} child))
  ([props child]
   [:span
    {:class (<class style/text props)}
    child]))
